var n = 6e4, i = 36e5, e = 1e3;
export {
  i as millisecondsInHour,
  n as millisecondsInMinute,
  e as millisecondsInSecond
};
